export const environment = {
  production: false,
  apiUrl: 'https://api.npr.centurycodes.ng/api/v1',
  /** URL of the standalone npr_auth app. All login/register flows redirect here. */
  authUrl: 'https://auth.npr.centurycodes.ng',
  /** Auto-login in local dev when no session exists (requires seeded applicant user). */
  devAutoLogin: false,
  devLogin: {
    login: 'applicant@npr.test',
    password: 'password',
  },
};
